import { render, staticRenderFns } from "./rolePrivileges.vue?vue&type=template&id=329436d9&scoped=true"
import script from "./rolePrivileges.vue?vue&type=script&lang=js"
export * from "./rolePrivileges.vue?vue&type=script&lang=js"
import style0 from "./rolePrivileges.vue?vue&type=style&index=0&id=329436d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329436d9",
  null
  
)

export default component.exports